var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("a", { attrs: { name: "scenario_compare" } }),
    _vm._v(" "),
    _c("fieldset", { staticStyle: { border: "2px groove" } }, [
      _c("legend", [
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-white bold",
            attrs: { id: "showCompare", type: "button" },
            on: {
              click: function ($event) {
                _vm.showCompare = !_vm.showCompare
              },
            },
          },
          [_vm._v("\n        -\n      ")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "ml-2 bold" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("financial-tools.sc_comp_title")) +
              "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.showCompare
        ? _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col"),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("financial-tools.sc_comp_sel_base_tools")
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("financial-tools.sc_comp_scn")) +
                          "\n          "
                      ),
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " + _vm._s(sms.savedScenarioId)
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.mortgage_amount")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatMoney(_vm.sbmort.totalLoanAmount)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatMoney(sms.totalLoanAmount))
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.interest_rate")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatRate(_vm.sbmort.netRate)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatRate(sms.netRate))
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.paymentFrequency")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "application-form." + _vm.sbmort.paymentFrequencyDd
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  sms.paymentFrequencyDd
                                    ? _vm.$t(
                                        "application-form." +
                                          sms.paymentFrequencyDd
                                      )
                                    : ""
                                )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("financial-tools.sc_list1_Fp")) + ": "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatMoney(_vm.sbmort.pAndIPaymentAmount)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatMoney(sms.pAndIPaymentAmount))
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("application-form.compounding-period")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "application-form." + _vm.sbmort.interestCompoundDd
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "application-form." + sms.interestCompoundDd
                                  )
                                )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("application-form.term")) + ": "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatTerm(_vm.sbmort.actualPaymentTerm)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatTerm(sms.actualPaymentTerm))
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.sc_comp_sel_term_pr")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatMoney(_vm.sbmort.termPrincipal)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatMoney(sms.termPrincipal))
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.sc_comp_sel_term_in")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatMoney(_vm.sbmort.termInterest)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatMoney(sms.termInterest))
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.balanceRemaining")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatMoney(_vm.sbmort.balanceRemaining)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatMoney(sms.balanceRemaining))
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("financial-tools.effectiveAmortization")
                        ) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.formatTerm(_vm.sbmort.effectiveAmortization)
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatTerm(sms.effectiveAmortization)
                                )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.sc_comp_sel_amort_pr")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.formatMoney(_vm.sbmort.amortizationPrincipal)
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatMoney(sms.amortizationPrincipal)
                                )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.sc_comp_sel_amort_in")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.formatMoney(_vm.sbmort.amortizationInterest)
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatMoney(sms.amortizationInterest)
                                )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { staticClass: "ml-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("financial-tools.sc_comp_sel_int_dif")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col"),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      sms.savedScenarioId > 0
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatMoneySign(sms.interestDifference)
                                )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col"),
                  _vm._v(" "),
                  _c("b-col"),
                  _vm._v(" "),
                  _vm._l(_vm.bean.selectedMS, function (sms, ind) {
                    return _c("b-col", { key: ind }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedScenarioIndex,
                            expression: "selectedScenarioIndex",
                          },
                        ],
                        attrs: {
                          id: "scSelectIndicator" + ind,
                          type: "radio",
                          name: "scenarioCompareSelect",
                          disabled: sms.savedScenarioId <= 0,
                        },
                        domProps: {
                          value: ind,
                          checked: _vm._q(_vm.selectedScenarioIndex, ind),
                        },
                        on: {
                          change: function ($event) {
                            _vm.selectedScenarioIndex = ind
                          },
                        },
                      }),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _vm.isEmbedded
                    ? _c(
                        "b-col",
                        { staticClass: "ml-3" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-white bold",
                              attrs: {
                                id: "setAsScenarioMortgageButton",
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.checkScenarioAsMortgage()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "financial-tools.sc_comp_button_set_as_mort"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.bottom.html",
                                value: {
                                  title: _vm.$t(
                                    "financial-tools.sc_comp_set_as_mort_text"
                                  ),
                                  customClass: "ml-2 tooltip-left",
                                },
                                expression:
                                  "{\n              title: $t('financial-tools.sc_comp_set_as_mort_text'),\n              customClass: 'ml-2 tooltip-left'\n            }",
                                modifiers: { bottom: true, html: true },
                              },
                            ],
                            attrs: { name: "info-circle" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("generic-modal", {
                    ref: "confirm-set-modal",
                    attrs: {
                      id: "confirm-set-modal",
                      "modal-dialog-size": "md",
                      "modal-dialog-scrollable": false,
                      "footer-close-button-text": _vm
                        .$t("global.words.cancel")
                        .toString(),
                      "tab-index": null,
                    },
                    on: {
                      show: function ($event) {
                        _vm.showModalShow = true
                      },
                      hidden: function ($event) {
                        _vm.showModalShow = false
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("financial-tools.SB_CONFIRM_M28")
                                  )
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "footer",
                          fn: function () {
                            return [
                              _c(
                                "simple-button",
                                {
                                  attrs: {
                                    type: "button",
                                    "class-name": "btn btn-danger btn-sm",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setScenarioAsMortgage()
                                    },
                                  },
                                },
                                [_vm._v("\n              OK\n            ")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2571805236
                    ),
                  }),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-white bold ml-2",
                          attrs: {
                            id: "replaceScenariosButton",
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.replaceScenarios()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("financial-tools.sc_comp_button_repl_sc")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("icon", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.bottom.html",
                            value: {
                              title: _vm.$t("financial-tools.sc_comp_text"),
                              customClass: "ml-2 tooltip-left",
                            },
                            expression:
                              "{\n              title: $t('financial-tools.sc_comp_text'),\n              customClass: 'ml-2 tooltip-left'\n            }",
                            modifiers: { bottom: true, html: true },
                          },
                        ],
                        attrs: { name: "info-circle" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col"),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "simple-button",
                        {
                          staticClass: "p-0",
                          attrs: {
                            id: "printAllButton",
                            type: "primary",
                            loading: _vm.isLoading,
                            "loading-succeeded": _vm.loadingSucceeded,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.printallScenarios()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "financial-tools.sc_comp_button_print_sc"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "m-1" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("financial-tools.sc_comp_text1_tools")) +
                    "\n      "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }